module.exports = __webpack_public_path__ + "media/src/application/media/route_2-fee23c7113c0131287db0da230fcc063.webp";